import React, { memo, useState } from 'react';
import styles from './IconItem.module.less';

export default memo(({ info }) => {
  const [show, setShow] = useState(false);

  return (
    <div className={styles.item}>
      <img src={info.icon} onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} />
      {show && (
        <div className={styles.title}>
          {info.name}
          {info.level}
        </div>
      )}
    </div>
  );
});
